import { videoHotlineCatgoryConstants } from "./constants/videoHotlineCategoryConstants";

const videoHotlineCategoryGetByFilter = (data: any) => {
	return {
		type: videoHotlineCatgoryConstants.VideoHotlineCategoryGetByfilterRequest,
		input: data,
	};
};

const videoHotlineCategoryUpdateStatus = (data: any) => {
	return {
		type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateStatusRequest,
		input: data,
	};
};

const videoHotlineCategoryCreate = (data: any) => {
	return {
		type: videoHotlineCatgoryConstants.VideoHotlineCategoryCreateRequest,
		input: data,
	};
};

const videoHotlineCategoryUpdate = (data: any) => {
	return {
		type: videoHotlineCatgoryConstants.VideoHotlineCategoryUpdateRequest,
		input: data,
	};
};

const videoHotlineCategoryDelete = (id: any) => {
	return {
		type: videoHotlineCatgoryConstants.VideoHotlineCategoryDeleteRequest,
		input: id
	};

};

export const VideoHotlineCategoryAction = {
	videoHotlineCategoryGetByFilter,
    videoHotlineCategoryUpdateStatus,
    videoHotlineCategoryCreate,
	videoHotlineCategoryUpdate,
	videoHotlineCategoryDelete
};
